import classes from "./MainNavigation.module.css";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { logoutActions } from "../store/user";
import { useState } from "react";

export default function MainNavigation() {
  const userData = useSelector((state) => state.myUser.userData);

  const[isOpen, setIsOpen] = useState(false);

  const token = userData?.token;
  const name = userData?.name;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleLogout() {
    dispatch(logoutActions());
    navigate("../login");
  }

  function handleNameClick(){
    setIsOpen(prev => !prev);
  }

  return (
    <header className={classes.header}>
      <nav className={classes.navbar}>
        <h2>DSA Open-Book Workshop</h2>
        <ul className={classes.menu}>
          <NavLink to="/">Home</NavLink> 
          <NavLink to="/rules">Guidelines</NavLink>
          <NavLink to="/updates">Updates</NavLink>          
          {token && (
            <ul>
              <NavLink to="/question">Question</NavLink>
                <button onClick={handleNameClick}>Hii, {name}</button>
                {isOpen &&  
                <NavLink onClick={handleLogout} className="logout-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      width="20"
                      height="20"
                      style={{ marginRight: "8px" }}
                    >
                    <path d="M16.08 13H7v-2h9.08l-2.59-2.59L14.5 7l5 5-5 5-1.41-1.41L16.08 13z" />
                    <path d="M12 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7v-2H5V6h7z" />
                    </svg>
                </NavLink>}
            </ul>
          )}
        </ul>
      </nav>
    </header>
  );
}
